import { Button, Image, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutInvitedCarrierWithPrequalQuickInfo extends Layout {
    imageWarning: Image;
    labelDotOk: Label;
    labelInsuranceOk: Label;
    labelPrequalWarningMessage: Label;
    labelWarning: Label;
    panelPrequalWarning: Panel;
    textboxInvitedBy: Textbox;
    textboxInvitedDate: Textbox;
    vendorSiteBtn: Button;
}
